import { render, staticRenderFns } from "./SystemCapitalRecord.vue?vue&type=template&id=732a1a8e&scoped=true&"
import script from "./SystemCapitalRecord.vue?vue&type=script&lang=js&"
export * from "./SystemCapitalRecord.vue?vue&type=script&lang=js&"
import style0 from "./SystemCapitalRecord.vue?vue&type=style&index=0&id=732a1a8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a1a8e",
  null
  
)

export default component.exports